import PropTypes from '../_util/vue-types';
export default {
  props: {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  },
  isSelectOptGroup: true
};


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/vc-select/OptGroup.js
// module id = 364
// module chunks = 0